import { namespace as createVuexClass } from 'vuex-class';
import { DatV2 } from 'ctp-toll-domain';

export const namespace = 'dats';
export const store = createVuexClass(namespace);

export const FETCH_DATS = 'fetchDats';
export const CREATE_DAT = 'createDat';
export const CREATE_DAT_VERSION = 'createDatVersion';
export const EDIT_DAT = 'editDat';
export const EDIT_DAT_VERSION = 'editDatVersion';
export const ARCHIVE_DAT = 'archiveDat';
export const DELETE_DAT = 'deleteDat';
export const DELETE_VERSION = 'deleteVersion';
export const UPDATE_DATS_STATE = 'updateDatsState';
export const SET_ERROR = 'setError';
export const SET_NOTIFICATION = 'setNotification';

export interface IDatsValueState {
  [view: string]: boolean;
}

export interface INotification {
  notificationStatus: string;
  code: number;
  content?: string;
  field?: string;
}
export interface INavigation {
  start: number;
  filesPerPage: number;
  direction: 'backward' | 'forward';
  isLastFilePage: boolean;
}

export interface IDatsStatePayload {
  stateKey: string;
  view: string;
  stateValue: boolean;
}

export interface IDatsState {
  [state: string]: IDatsValueState;
}

export interface DatsState {
  datsState: IDatsState;
  dats: Array<DatV2>;
  errorMessage: string;
  notification: INotification | undefined;
}

export enum DatStateEnum {
  Deleted = 'deleted',
  Archived = 'archived',
  Requested = 'requested',
  Active = 'active',
  Pending = 'pending',
  Inactive = 'inactive'
}

export enum DatFlagEnum {
  Unused = 'unused',
  Used = 'used'
}
